import React from 'react';
import { SSpinner } from '@chargebee/sting-react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';

export type SuspenseLoaderProps = {
  message?: string;
  /** Explicit opt-in: hosted rendering and legacy Play retain their loader. */
  presentation?: 'legacy' | 'sting';
};

export const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({
  message,
  presentation = 'legacy',
}) =>
  presentation === 'sting' ? (
    <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-gap-3 tw-text-sm tw-leading-5 tw-text-neutral-600">
      <SSpinner
        size="medium"
        className="tw-shrink-0 [&_circle]:!tw-fill-none"
      />
      {(message ?? 'Loading...').trim() && (
        <span>{message ?? 'Loading...'}</span>
      )}
    </div>
  ) : (
    <div
      className={cs(
        'tw-h-full tw-w-full',
        'tw-flex tw-items-center tw-justify-center',
        'tw-cursor-progress tw-text-neutral-300',
        '[&_svg]:tw-h-16 [&_svg]:tw-w-16'
      )}
    >
      {Icons.loaderSW6} {message ?? 'Loading...'}
    </div>
  );
